import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { SmoothScroll, ScrollToTop } from "@/components/SmoothScroll";
import { ScrollProgress, SectionCrossfade } from "@/components/ScrollFX";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { StickyDemoBar } from "@/components/StickyDemoBar";
import Home from "@/pages/Home"; // eager: LCP page

// Route-level code splitting — each becomes its own JS chunk.
const Platform = lazy(() => import("@/pages/Platform"));
const Services = lazy(() => import("@/pages/Services"));
const ProjectManagement = lazy(() => import("@/pages/ProjectManagement"));
const MedicalBillingRCM = lazy(() => import("@/pages/MedicalBillingRCM"));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
const TermsOfService = lazy(() => import("@/pages/TermsOfService"));
const BehavioralHealth = lazy(() => import("@/pages/BehavioralHealth"));
const FitQuiz = lazy(() => import("@/pages/FitQuiz"));
const Resources = lazy(() => import("@/pages/Resources"));
const Programs = lazy(() => import("@/pages/Programs"));
const ProgramDetail = lazy(() => import("@/pages/ProgramDetail"));
const Calculator = lazy(() => import("@/pages/Calculator"));
const Compliance = lazy(() => import("@/pages/Compliance"));
const Implementation = lazy(() => import("@/pages/Implementation"));
const Contact = lazy(() => import("@/pages/Contact"));
const AdminInsights = lazy(() => import("@/pages/AdminInsights"));
const Insights = lazy(() => import("@/pages/Insights"));
const InsightDetail = lazy(() => import("@/pages/InsightDetail"));
const AuthorPage = lazy(() => import("@/pages/AuthorPage"));

const PageFallback = () => (
  <div className="min-h-[70vh] grid place-items-center bg-white" aria-busy="true">
    <div className="h-8 w-8 rounded-full border-2 border-slate-200 border-t-zoc-teal animate-spin" />
  </div>
);

function App() {
  return (
    <div className="App">
      <HelmetProvider>
      <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <SectionCrossfade />
          <ScrollProgress />
          <Navbar />
          <main>
            <Suspense fallback={<PageFallback />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/platform" element={<Platform />} />
                <Route path="/services" element={<Services />} />
                <Route path="/project-management" element={<ProjectManagement />} />
                <Route path="/medical-billing-rcm" element={<MedicalBillingRCM />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/behavioral-health" element={<BehavioralHealth />} />
                <Route path="/fit" element={<FitQuiz />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/programs" element={<Programs />} />
                <Route path="/programs/:slug" element={<ProgramDetail />} />
                <Route path="/calculator" element={<Calculator />} />
                <Route path="/compliance" element={<Compliance />} />
                <Route path="/implementation" element={<Implementation />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/insights" element={<Insights />} />
                <Route path="/insights/:slug" element={<InsightDetail />} />
                <Route path="/authors/:slug" element={<AuthorPage />} />
                <Route path="/admin/insights" element={<AdminInsights />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
          <StickyDemoBar />
        </SmoothScroll>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
